// Topic buckets for the guides explorer (/guides/). Guides carry no category
// front matter, so topics are derived from the slug with first-match-wins
// precedence; anything unmatched lands in "Site safety basics".

export type GuideTopic = "coshh" | "rams" | "risk" | "regs" | "basics";

export const GUIDE_TOPICS: Record<GuideTopic, { label: string; blurb: string }> = {
  rams: {
    label: "RAMS & method statements",
    blurb: "What a RAMS is, how to write and structure one, and what reviewers expect to see.",
  },
  risk: {
    label: "Risk assessment",
    blurb: "Scoring, matrices, hazards and how to write a risk assessment that stands up to review.",
  },
  coshh: {
    label: "COSHH & substances",
    blurb: "Hazardous substances: COSHH assessments, safety data sheets and how they relate to RAMS.",
  },
  regs: {
    label: "Regulations explained",
    blurb: "CDM 2015, PUWER, RIDDOR, permits and the other regulations behind the paperwork.",
  },
  basics: {
    label: "Site safety basics",
    blurb: "Policies, training, responsibilities and the everyday paperwork of running safe site work.",
  },
};

export const GUIDE_TOPIC_ORDER: GuideTopic[] = ["rams", "risk", "coshh", "regs", "basics"];

const RULES: { topic: GuideTopic; pattern: RegExp }[] = [
  { topic: "coshh", pattern: /coshh|safety-data-sheets/ },
  { topic: "rams", pattern: /rams|method-statement/ },
  { topic: "risk", pattern: /risk-assessment|hazard|5x5|5-steps|near-miss/ },
  { topic: "regs", pattern: /cdm|regulations|puwer|riddor|work-act|construction-phase-plan|permit/ },
];

export function guideTopic(slug: string): GuideTopic {
  for (const r of RULES) if (r.pattern.test(slug)) return r.topic;
  return "basics";
}
